import styled from "@emotion/styled"
import Dialog from "@mui/material/Dialog"

const StyledProgramDialog = styled(Dialog)`
  .MuiPaper-root {
    width: min(1180px, calc(100vw - 28px));
    max-width: none;
    border-radius: 20px;
    border: 1px solid var(--cms-border);
    background: var(--cms-dialog-bg);
    box-shadow: 0 28px 54px rgba(15, 23, 42, 0.2);
  }

  .MuiDialogTitle-root {
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
    gap: 12px;
    padding: 20px 24px 8px;
  }

  .dialog-title-group {
    display: flex;
    flex-direction: column;
    gap: 5px;
  }

  .dialog-title {
    margin: 0;
    font-size: 22px;
    font-weight: 800;
    color: var(--cms-text-primary);
    letter-spacing: -0.01em;
  }

  .dialog-subtitle {
    margin: 0;
    font-size: 13px;
    color: var(--cms-text-secondary);
    font-weight: 500;
  }

  .MuiDialogContent-root {
    min-height: 400px;
    padding: 14px 24px 10px;
  }

  .MuiDialogActions-root {
    padding: 10px 24px 20px;
    gap: 10px;
  }

  .dialog-cancel-btn,
  .dialog-submit-btn,
  .dialog-secondary-btn {
    text-transform: none;
    border-radius: 10px;
    min-height: 40px;
    font-weight: 700;
    padding: 8px 14px;
  }

  .dialog-cancel-btn,
  .dialog-secondary-btn {
    color: var(--cms-text-primary);
    border-color: var(--cms-border);
  }

  .dialog-submit-btn {
    min-width: 108px;
    box-shadow: 0 12px 24px rgba(37, 99, 235, 0.24);
  }

  .form-control-row {
    padding-top: 10px;
    &.two-col {
      display: flex;
      flex-wrap: wrap;
      > div {
        margin-right: 20px;
      }
    }
  }

  .title-bar {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
    margin: 12px 0 10px;

    label {
      font-size: 14px;
      color: var(--cms-text-primary);
      font-weight: 800;
    }
  }

  .category-section {
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    gap: 8px;
    padding: 12px;
    border-radius: 12px;
    font-size: 13px;
    border: 1px solid var(--cms-border);
    background: var(--cms-surface-muted);
    color: var(--cms-text-primary);

    .category-item {
      display: inline-block;
      border-radius: 999px;
      padding: 6px 10px;
      background: var(--cms-selected-bg);
      border: 1px solid var(--cms-border);
      color: var(--cms-link-color);
      font-size: 12px;
      font-weight: 700;
    }
  }

  .contributor-section {
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    gap: 8px;
    margin-bottom: 25px;
    .MuiChip-root {
      margin-right: 0;
      border-radius: 999px;
      border: 1px solid var(--cms-border);
      background: var(--cms-selected-bg);
      color: var(--cms-link-color);
      font-weight: 700;
    }
  }
  .error-message {
    color: #b91c1c;
    margin: 8px 0 0 2px;
    font-size: 12px;
    font-weight: 600;
  }
  .dialog-content {
    max-height: calc(100vh - 200px);
  }

  .image-select-frame {
    display: flex;
    height: 200px;
    width: 330px;
    border: 2px dashed var(--cms-border);
    font-size: 16px;
    color: var(--cms-text-secondary);
    align-items: center;
    justify-content: space-around;
    margin-left: 8px;
    cursor: pointer;
    text-transform: capitalize;
    padding: 10px;
    border-radius: 5px;
  }

  .questions {
    margin: 20px 0;
    .action-bar {
      margin-bottom: 15px;
    }
    .question-list {
      .question {
        background-color: var(--cms-surface-muted);
        padding: 7px 20px;
        margin: 5px 0;
        border-radius: 4px;
        color: var(--cms-text-primary);
        font-size: 12px;

        .title {
          font-weight: 600;
          display: flex;
          flex-direction: row;
          align-items: center;
          justify-content: space-between;
          margin-bottom: 10px;

          .content {
            .MuiChip-root {
              min-width: 120px;
              margin-right: 10px;
            }
          }

          .actions {
            .MuiButtonBase-root {
              margin-left: 3px;
            }
          }
        }

        ol {
          margin: -5px 0px 3px -15px;
          li {
            margin: 0 0 0 0;
          }
        }
      }
    }
  }

  .attachments-section {
    .attachment-list {
      display: flex;
      border: 1px dashed var(--cms-border);
      border-radius: 10px;
      padding: 12px 10px;
      margin: 10px 0;
      font-size: 12px;
      color: var(--cms-text-secondary);
      justify-content: flex-start;
      flex-wrap: wrap;

      .attachment-item {
        position: relative;
        margin-right: 30px;
        .info {
          padding: 10px 5px 10px 10px;
        }
        .attachment-close-btn {
          position: absolute;
          right: -2px;
          top: -4px;
        }
      }
    }
  }
`

const StyledProgramWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 14px;
  padding: 20px 22px 24px;
  border-radius: 24px;
  background: var(--cms-surface-primary);
  color: var(--cms-text-primary);

  .heading-copy {
    display: flex;
    flex-direction: column;
    gap: 6px;
  }

  .page-title {
    margin: 0;
    font-size: 30px;
    font-weight: 800;
    color: var(--cms-text-primary);
    letter-spacing: -0.01em;
  }

  .page-subtitle {
    margin: 0;
    color: var(--cms-text-secondary);
    font-size: 13px;
    font-weight: 500;
  }

  .new-program-btn {
    text-transform: none;
    font-weight: 700;
    border-radius: 10px;
    min-height: 40px;
    padding: 8px 16px;
    box-shadow: 0 12px 24px rgba(37, 99, 235, 0.24);
  }

  .page-surface {
    border: 1px solid var(--cms-border);
    border-radius: 18px;
    background: var(--cms-surface-secondary);
    box-shadow: var(--cms-shadow);
    padding: 14px;
  }

  .page-empty {
    display: flex;
    align-items: center;
    justify-content: center;
    min-height: 120px;
    border: 1px dashed var(--cms-border);
    border-radius: 14px;
    font-size: 14px;
    font-weight: 600;
    color: var(--cms-text-secondary);
    background: var(--cms-surface-muted);
  }

  .MuiDialogContent-root {
    padding-top: 20px !important;
  }

  .filter-bar {
    display: flex;
    flex-wrap: wrap;
    gap: 10px;
    align-items: center;
    background: var(--cms-surface-muted);
    border: 1px solid var(--cms-border);
    padding: 14px;
    margin-bottom: 10px;
    border-radius: 14px;
    box-shadow: var(--cms-shadow);
    width: 100%;
    box-sizing: border-box;

    .MuiFormControl-root {
      margin: 0;
      min-width: 210px;
    }

    .clear-btn {
      text-transform: none;
      font-weight: 700;
      border-radius: 10px;
      min-height: 40px;
      padding: 8px 14px;
    }
  }

  .MuiTableContainer-root {
    border: 1px solid var(--cms-border);
    border-radius: 12px;
    overflow: hidden;
    box-shadow: 0 12px 24px rgba(15, 23, 42, 0.06);
  }

  .MuiTableCell-head {
    background: var(--cms-table-head-bg);
    color: var(--cms-text-primary);
    font-weight: 700;
    font-size: 12px;
    border-bottom: 1px solid var(--cms-border);
  }

  .MuiTableCell-body {
    font-size: 13px;
    color: var(--cms-text-primary);
    border-bottom: 1px solid var(--cms-border);
    vertical-align: top;
  }

  .action-cell {
    min-width: 220px;
    .actions-wrap {
      display: flex;
      justify-content: flex-end;
      gap: 6px;
      flex-wrap: wrap;
    }
  }

  .category-tag {
    display: inline-block;
    border-radius: 999px;
    padding: 5px 10px;
    background: var(--cms-selected-bg);
    color: var(--cms-link-color);
    border: 1px solid var(--cms-border);
    margin: 0 6px 6px 0;
    font-size: 11px;
    font-weight: 700;
  }

  .table-empty {
    text-align: center;
    color: var(--cms-text-secondary);
    font-weight: 600;
    padding: 18px;
  }
`

const StyledProgramSectionPanel = styled.div`
  padding: 15px 25px 15px 15px;
  margin-top: 20px;
  box-shadow: rgba(60, 64, 67, 0.3) 0px 1px 2px 0px,
    rgba(60, 64, 67, 0.15) 0px 2px 6px 2px;
  border-radius: 5px;
  .error-label {
    font-size: 12px;
    color: red;
    margin: 10px;
  }

  .action-bar {
    display: flex;
    align-items: center;

    button {
      height: 55px;
    }
  }
`

// program card section
const StyledProgramLevelContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  flex-wrap: wrap;
`

const StyledProgramLevelCard = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
  box-shadow: rgba(0, 0, 0, 0.05) 0px 6px 24px 0px,
    rgba(0, 0, 0, 0.08) 0px 0px 0px 1px;
  border-radius: 5px;
  margin: 5px;
  padding: 20px;
  background-color: var(--cms-surface-secondary);
  border: 1px solid var(--cms-border);
  color: var(--cms-text-primary);

  .label {
    font-size: 16px;
    color: var(--cms-text-secondary);
    font-weight: bold;
  }

  .header {
    display: flex;
    justify-content: space-between;
    align-content: center;
    font-size: 18px;
    font-weight: 600;

    .MuiChip-root {
      transform: scale(0.75);
      margin: -15px 7px 0 6px;
    }
  }

  .innercise-header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin: 10px 0;
    /* border-bottom: 1px dashed #9f7171; */
    padding: 7px 0;
  }

  .btn {
    cursor: pointer;
    color: var(--cms-text-secondary);
    &:hover {
      color: red;
    }
  }

  .close-btn {
  }
  .edit-btn {
    width: 20px;
    height: 20px;
    margin: 0 9px 3px 0px;
  }
  .title {
    font-size: 16px;
    font-weight: 400;
    margin: 10px 0;
  }

  .innercise-list {
    display: flex;
    flex-direction: column;
    overflow: auto;
    padding: 0;
    transition: max-height 0.25s ease;
    max-height: 520px;
    gap: 6px;

    &.hide {
      max-height: 0;
      overflow: hidden;
      transition: max-height 0.25s ease;
    }

    /* Vertical list: reliable drop targeting for react-smooth-dnd
       (horizontal + flex-wrap created huge inter-row gaps). */
    .smooth-dnd-container.vertical {
      display: flex;
      flex-direction: column;
      width: 100%;
      gap: 6px;
    }

    .innercise-drop-zone {
      min-height: 48px;
    }

    .smooth-dnd-draggable-wrapper {
      display: block;
      height: auto !important;
    }

    .innercise-drop-placeholder {
      background-color: rgba(93, 143, 45, 0.12);
      border: 1px dashed #5d8f2d;
      border-radius: 6px;
      margin: 0 !important;
      min-height: 56px;
    }
  }

  .innercise-item {
    display: flex;
    flex-direction: row;
    align-items: center;
    gap: 10px;
    width: 100%;
    min-height: 56px;
    height: auto;
    box-sizing: border-box;
    border-radius: 6px;
    box-shadow: rgba(60, 64, 67, 0.3) 0px 1px 2px 0px,
      rgba(60, 64, 67, 0.15) 0px 1px 3px 1px;
    margin: 0;
    font-size: 13px;
    padding: 6px 8px;
    background: var(--cms-surface-muted);
    border: 1px solid var(--cms-border);

    .drag-handle {
      flex: 0 0 auto;
      cursor: grab;
      color: var(--cms-text-secondary);
    }
    .drag-handle:active {
      cursor: grabbing;
    }

    .thumb {
      flex: 0 0 56px;
      width: 56px;
      height: 56px;
      border-radius: 4px;
      overflow: hidden;
      background: var(--cms-surface-secondary);

      img {
        width: 100%;
        height: 100%;
        object-fit: cover;
        border-radius: 4px;
        display: block;
      }

      .thumb-empty {
        width: 100%;
        height: 100%;
        background: var(--cms-hover-bg);
      }
    }

    .meta {
      flex: 1 1 auto;
      min-width: 0;
      display: flex;
      flex-direction: column;
      gap: 2px;
    }

    .id-label {
      font-size: 11px;
      color: var(--cms-text-secondary);
      line-height: 1.2;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
    }

    .title {
      font-size: 13px;
      font-weight: 600;
      line-height: 1.3;
      margin: 0;
      padding: 0;
      height: auto;
      max-height: 2.6em;
      overflow: hidden;
      display: -webkit-box;
      -webkit-line-clamp: 2;
      -webkit-box-orient: vertical;
      background: transparent;
      width: auto;
      color: var(--cms-text-primary);
    }

    .icon-btn {
      display: flex;
      flex: 0 0 auto;
      align-items: center;
      gap: 2px;

      .MuiIconButton-root {
        padding: 4px;
      }
    }
  }
`

const StyledProgramContributorDialog = styled(Dialog)`
  .MuiPaper-root {
    width: min(840px, calc(100vw - 28px));
    border-radius: 18px;
    border: 1px solid var(--cms-border);
    background: var(--cms-dialog-bg);
    box-shadow: 0 24px 48px rgba(15, 23, 42, 0.2);
  }

  .MuiDialogTitle-root {
    padding: 18px 22px 8px;
    font-size: 20px;
    font-weight: 800;
    color: var(--cms-text-primary);
    letter-spacing: -0.01em;
  }

  .MuiDialogContent-root {
    padding: 10px 22px 10px;
  }

  .MuiDialogActions-root {
    padding: 8px 22px 18px;
    gap: 10px;
  }

  .dialog-content {
    max-height: calc(100vh - 200px);
  }
  .search-bar {
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    gap: 8px;
    width: 100%;
    align-items: center;
    padding: 12px;
    border-radius: 12px;
    background: var(--cms-surface-muted);
    border: 1px solid var(--cms-border);
    box-shadow: 0 10px 22px rgba(15, 23, 42, 0.06);
    align-items: center;
    .MuiFormControl-root {
      margin-right: 0;
      width: 260px;
    }

    .MuiButton-root {
      height: 40px;
      margin-top: 0;
      margin-right: 0;
      border-radius: 9px;
      text-transform: none;
      font-weight: 700;
    }
  }

  .search-result {
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    gap: 8px;
    width: 100%;
    align-items: flex-start;
    margin-top: 12px;
    padding: 12px;
    border-radius: 12px;
    border: 1px solid var(--cms-border);
    background: var(--cms-surface-muted);
    box-shadow: var(--cms-shadow);
    min-height: 90px;
    font-size: 14px;
    overflow-y: auto;
    .MuiChip-root {
      margin-right: 0;
      border-radius: 999px;
      font-weight: 700;
    }
  }
`

const StyledProgramSingleInnerciseControl = styled.div`
  display: flex;
  flex-direction: column;
  .input-group {
    display: flex;
    flex-direction: column;
    &.flex-row {
      flex-direction: row;
    }
  }

  .innercise-channel {
    display: inline-block;
    .channel-label {
      font-size: 14px;
      font-weight: 400;
      margin: 7px 0px 0px 10px;
    }
  }
`

export {
  StyledProgramDialog,
  StyledProgramWrapper,
  StyledProgramSectionPanel,
  StyledProgramLevelContainer,
  StyledProgramLevelCard,
  StyledProgramContributorDialog,
  StyledProgramSingleInnerciseControl,
}
